// extracted by mini-css-extract-plugin
module.exports = {"content":"Home_content__172Av","sidenav":"Home_sidenav__1VukA","details":"Home_details__1h5Kg"};